import { createAction } from '@reduxjs/toolkit';

export const couponUpdateId = createAction('coupon/updateId');
export const couponUpdateUID = createAction('coupon/updateUID');
export const couponUpdateSID = createAction('coupon/updateSid');
export const couponUpdateIsAdded = createAction('coupon/updateIsAdded');
export const couponUpdateIsActive = createAction('coupon/updateIsActive');

export const couponStore = createAction('coupon/store');
export const couponClear = createAction('coupon/clear');

export const couponUpdateRequest = createAction('coupon/updateRequest');
export const couponUpdateError = createAction('coupon/updateError');
export const couponUpdateStore = createAction('coupon/updateStore');

export const couponUpdateItems = createAction('coupon/updateItems');
export const couponUpdateView = createAction('coupon/updateView');

export const couponUpdateHeadingTitle = createAction('coupon/updateHeadingTitle');
export const couponUpdateHeadingDescription = createAction('coupon/updateHeadingDescription');
export const couponUpdateHeadingTextAlign = createAction('coupon/updateHeadingTextAlign');
export const couponUpdateHeadingImage = createAction('coupon/updateHeadingImage');
export const couponUpdateHeadingDivider = createAction('coupon/updateHeadingDivider');

export const couponUpdateSectionIsBackground = createAction('coupon/updateSectionIsBackground');
export const couponUpdateSectionTextColor = createAction('coupon/updateSectionTextColor');
export const couponUpdateSectionBackgroundColor = createAction('coupon/updateSectionBackgroundColor');
export const couponUpdateSectionOpacity = createAction('coupon/updateSectionOpacity');
export const couponUpdateSectionIsFullWidth = createAction('coupon/updateSectionIsFullWidth');
export const couponUpdateSectionShadow = createAction('coupon/updateSectionShadow');
export const couponUpdateSectionShadowColor = createAction('coupon/updateSectionShadowColor');
export const couponUpdateSectionPadding = createAction('coupon/updateSectionPadding');
export const couponUpdateSectionMargin = createAction('coupon/updateSectionMargin');
export const couponUpdateSectionBackgroundType = createAction('coupon/updateSectionBackgroundType');
export const couponUpdateSectionBackgroundImage = createAction('coupon/updateSectionBackgroundImage');
export const couponUpdateSectionGradientColor1 = createAction('coupon/updateSectionGradientColor1');
export const couponUpdateSectionGradientColor2 = createAction('coupon/updateSectionGradientColor2');
export const couponUpdateSectionGradientDirection = createAction('coupon/updateSectionGradientDirection');
export const couponUpdateSectionGradientOffset = createAction('coupon/updateSectionGradientOffset');
export const couponUpdateSectionBorder = createAction('coupon/updateSectionBorder');
export const couponUpdateSectionBorderColor = createAction('coupon/updateSectionBorderColor');
export const couponUpdateSectionShadowBorderColor = createAction('coupon/updateSectionShadowBorderColor');
export const couponUpdateSectionShape = createAction('coupon/updateSectionShape');

export const couponUpdateItemShadow = createAction('coupon/updateItemShadow');
export const couponUpdateItemShadowColor = createAction('coupon/updateItemShadowColor');
export const couponUpdateItemBorder = createAction('coupon/updateItemBorder');
export const couponUpdateItemBorderColor = createAction('coupon/updateItemBorderColor');
export const couponUpdateItemShape = createAction('coupon/updateItemShape');
